import { type PaymentMethodSelectorDialogViewModel } from '@/features/billing/payment-methods/PaymentMethodSelectorDialog/PaymentMethodSelectorDialogViewModel'
import { PaymentMethodSelectorDialog } from '@/features/billing/payment-methods/PaymentMethodSelectorDialog'
import { PaymentMethodSelectorContainer } from '@/features/billing/payment-methods/PaymentMethodSelector/PaymentMethodSelectorContainer'
import { observer } from 'mobx-react-lite'

export interface PaymentMethodSelectorDialogContainerProps {
  vm: PaymentMethodSelectorDialogViewModel
}

export const PaymentMethodSelectorDialogContainer = observer(
  function PaymentMethodSelectorDialogContainer({
    vm,
  }: PaymentMethodSelectorDialogContainerProps) {
    const selectorVm = vm.selectorVm
    if (!selectorVm) {
      return null
    }

    return (
      <PaymentMethodSelectorDialog
        showing={vm.modal.showing}
        isDisabled={selectorVm.fetch.pending || selectorVm.selectMethod.pending}
        onClose={vm.modal.close}
      >
        <PaymentMethodSelectorContainer vm={selectorVm} />
      </PaymentMethodSelectorDialog>
    )
  },
)
